/*
 * Created By sswaminathan
 * Created on Mon Sep 13 2021
 * Created on MenuItems.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */
import { useCallback, useContext } from 'react'
import { Body, Button } from '@panwds/react-ui-legacy'
import { TasksIcon, UserCogIcon, BuildingIcon, ServerIcon, NetworkWiredIcon } from '@panwds/icons'
import {
  VIEW_DEVICE_ASSOCIATIONS,
  VIEW_MANAGE_IAM,
  VIEW_MANAGE_SUBSCRIPTION,
  VIEW_MANAGE_TENANT,
  VIEW_IP_ALLOW_LIST
} from '../../../common/constants/GlobalConstants'
import {
  MANAGE_LICENSE,
  MANAGE_SUBSCRIPTIONS,
  MANAGE_USER_AND_ROLE,
  MANAGE_DEVICE_ASSOCIATIONS,
  MANAGE_IP_ALLOW_LIST
} from '../../../common/constants/LabelConstants'
import { getVarValue, setCurrentViewing } from '../../../common/utils/Sparky'
import {
  FF_DAS_ENABLED,
  FF_SHOW_IAM,
  FF_SHOW_SUBSCRIPTIONS,
  FF_SHOW_TENANCY,
  canUseIpAllow
} from '../../../common/utils/FeatureFlags'
import AppContext from '../../../common/context/AppContext'
import AuthContext from '../../../common/context/AuthContext'
import { isAccountAllowedForDAS } from '../../../common/utils/Utils'
import GlobalContext from '../../../common/context/GlobalContext'

const dasEnabledFF = getVarValue(FF_DAS_ENABLED, false)
const tenancyEnabled = getVarValue(FF_SHOW_TENANCY, true)
const iamEnabled = getVarValue(FF_SHOW_IAM, true)
const subscriptionEnabled = getVarValue(FF_SHOW_SUBSCRIPTIONS, false)

const MenuItems = () => {
  const { treeReducer } = useContext(GlobalContext)
  const { apps } = useContext(AppContext)
  const { user } = useContext(AuthContext)
  const { selectedTreeNode } = treeReducer
  const dasEnabled = dasEnabledFF && isAccountAllowedForDAS(apps, user)
  const onMenuClick = useCallback(setCurrentViewing, [])
  const buttonClass = 'tw-flex tw-bg-blue-steel-900 tw-flex-row tw-justify-start tw-border-l-4 tw-border-blue-steel-900 dark:cm-border-black focus:tw-outline-none focus:tw-ring-offset-0 hover:tw-bg-blue-steel-700 dark:cm-bg-black hover:tw-border-blue-400 hover:tw-border-l-4 focus:tw-border-l-4 focus:tw-border-blue-400 active:tw-bg-blue-steel-700 dark:cm-bg-black dark:hover:tw-bg-gray-800 dark:focus:tw-bg-gray-800 dark:active:tw-bg-gray-700'

  return (
    <>
      {subscriptionEnabled && (
        <Button
          appearance='clear'
          fullWidth
          onClick={onMenuClick.bind(this, VIEW_MANAGE_SUBSCRIPTION)}
          icon={<TasksIcon size='md' className='tw-text-white' />}
          addClassName={buttonClass}
          size={'lg'}>
          <Body
            size='md'
            appearance='primary'
            addClassName='tw-pl-2 tw-text-white tw-color-primary tw-border-0'
          >
            {MANAGE_SUBSCRIPTIONS}
          </Body>
        </Button>
      )}
      {tenancyEnabled && (
        <Button
          appearance='clear'
          fullWidth
          onClick={onMenuClick.bind(this, VIEW_MANAGE_TENANT)}
          icon={<BuildingIcon size='md' className='tw-text-white' />}
          addClassName={buttonClass}
          size={'lg'}>
          <Body
            size='md'
            appearance='primary'
            addClassName='tw-pl-2 tw-text-white tw-color-primary tw-border-0'
          >
            {MANAGE_LICENSE}
          </Body>
        </Button>
      )}
      {iamEnabled && (
        <Button
          appearance='clear'
          fullWidth
          onClick={onMenuClick.bind(this, VIEW_MANAGE_IAM)}
          icon={<UserCogIcon size='md' className='tw-text-white' />}
          addClassName={buttonClass}
          size={'lg'}>
          <Body
            size='md'
            appearance='primary'
            addClassName='tw-pl-2 tw-text-white tw-color-primary tw-border-0'
          >
            {MANAGE_USER_AND_ROLE}
          </Body>
        </Button>
      )}
      {dasEnabled && (
        <Button
          appearance='clear'
          fullWidth
          onClick={onMenuClick.bind(this, VIEW_DEVICE_ASSOCIATIONS)}
          icon={<ServerIcon size="md" className="tw-text-white" />}
          addClassName={buttonClass}
          size={'lg'}>
          <Body
            size="md"
            appearance="primary"
            addClassName="tw-pl-2 tw-text-white tw-color-primary tw-border-0"
          >
            {MANAGE_DEVICE_ASSOCIATIONS}
          </Body>
        </Button>
      )}
      {canUseIpAllow(selectedTreeNode) && (
        <Button
          appearance='clear'
          fullWidth
          onClick={onMenuClick.bind(this, VIEW_IP_ALLOW_LIST)}
          icon={<NetworkWiredIcon size="md" className="tw-text-white" />}
          addClassName={buttonClass}
          size={'lg'}>
          <Body
            size="md"
            appearance="primary"
            addClassName="tw-pl-2 tw-text-white tw-color-primary tw-border-0"
          >
            {MANAGE_IP_ALLOW_LIST}
          </Body>
        </Button>
      )}
    </>
  )
}
export default MenuItems
